// @ts-check
import styled from 'styled-components';

export const StyledTitle = styled.p`
  font-size: 2.2rem;
`;

export const StyledDescription = styled.p`
  font-size: 1.4rem;
`;

export const StyledEmptyStateReportedWidget = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: auto;

  & ${StyledTitle} {
    margin: 4rem 0 0 0;
  }
`;
